export default class ResourceInUseError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ResourceInUseError";
  }
}
